import { Component } from "react";
import withNavigate from "../../components/withNavigate";
import { useLocation } from "react-router-dom";
import { Accordion, Col, Row } from "react-bootstrap";
import StorageService from '../../services/api/Storage/index.js';
import "../../assets/css/fileEditor.css";
import TreeView from "./TreeView.js";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import EditorView from "./EditorView.js";
import { FileEditContext } from "../file/FileEditContext.js";
import sun from "../../assets/img/icons/sun.png";
import moon from "../../assets/img/icons/moon.png";
import cloud from "../../assets/img/icons/cloud.png";
import storageLoad from "../../assets/img/storage_load.gif";

class FileEditorWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            height: window.innerHeight,
            loading: false,
            initialLoading: false,
            storageFiles: [],
            storageFolders: [],
            prefix: "",
            folderIndex: null,
            storageData: "",
            parentIndex: 0,
            selectedPath: "",
            searchWord: "",
            fileContextValue: [],
            expandView: false,
            toggleTheme: false
        }
        this.timeout = null;
    }

    componentDidMount() {
        this.setState({
            initialLoading: true
        }, () => {
            this.fetchStorageFilesFolders("Vijay/", null, [], []);
        })
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({
            height: window.innerHeight
        })
    }

    setFileContextValue = (value) => {
        this.setState({
            fileContextValue: value
        })
    }

    setExpandView = (value) => {
        this.setState({
            expandView: value
        })
    }

    fetchStorageFilesFolders = (prefix, pageToken, files, folders) => {
        let storageId = "68023331d540965cd5dc82b3";
        let rootFolder = null;
        this.setState({
            loading: true,
            initialLoading: this.state.storageFiles?.length + this.state.storageFolders?.length === 0 ? true : false,
            prefix: prefix,
        })
        StorageService.listObjects(prefix, storageId, rootFolder, pageToken)
            .then((response) => {
                let foldersSort = [...response?.prefixes].sort((a, b) => {
                    // convert to strings and force lowercase
                    a = typeof a === 'string' ? a.toLowerCase() : a.toString()
                    b = typeof b === 'string' ? b.toLowerCase() : b.toString()

                    return b.localeCompare(a)
                })
                let filesSort = [...response.result].sort((a, b) => {
                    // convert to strings and force lowercase
                    let _a = a["name"]
                    let _b = b["name"]
                    _a = typeof _a === 'string' ? _a.toLowerCase() : _a.toString()
                    _b = typeof _b === 'string' ? _b.toLowerCase() : _b.toString()
                    return _b.localeCompare(_a)
                })

                files = [...this.state.storageFiles, ...filesSort]
                folders = [...this.state.storageFolders, ...foldersSort];
                let folder = [];

                for (let item of folders) {
                    folder.push({
                        name: item,
                        file_name: this.trimFolderName(item),
                        files: []
                    })
                }

                this.setState({
                    loading: false,
                    initialLoading: false,
                    storageFiles: files,
                    storageFolders: folders,
                })
            }).catch((err) => {
                this.setState({
                    loading: false,
                    initialLoading: false
                })
            })
    }

    constructTreeData = (data, parentPath) => {
        const root = {};

        data?.folder?.forEach(folder => {
            const parts = folder.name.split("/").filter(Boolean);
            let current = root;
            for (const part of parts) {
                current[part] = current[part] || {}
                current = current[part];
            }
        });

        data?.root?.forEach(file => {
            const parts = file.name.split("/").filter(Boolean);
            const fileName = parts.pop();
            let current = root;
            for (const part of parts) {
                current[part] = current[part] || {};
                current = current[part];
            }
            current[fileName] = file; // attach full file info here
        });

        this.setState({
            storageData: root,
        })
    }

    trimFolderName = (folderName) => {
        if (folderName.endsWith('/')) {
            folderName = folderName.slice(0, -1);
        }
        return folderName.split('/').pop()
    };

    trimFileName = (fileName) => {
        return fileName.split('/').pop()
    };

    toggleFolder = (index) => {
        this.setState({
            folderIndex: index
        })
    }

    onFolderClick = (name, node, fullPath, index) => {
        this.setState({
            parentIndex: index,
            selectedPath: fullPath
        })
        this.fetchStorageFilesFolders(fullPath, null, [], []);
    }

    onFileClick = (name, node, fullPath) => {
        this.setState({
            selectedPath: fullPath
        })
    }

    treeNode = (node, name, path = "", index) => {
        const fullPath = path ? `${path}/${name}` : name;
        const isLeaf = typeof node !== "object" || node.created; // File objects have `created`

        if (isLeaf) {
            return <li className={`action-pointer ${fullPath === this.state.selectedPath ? 'selected' : ''}`}
                onClick={() => this.onFileClick(name, node, fullPath)}>{name}</li>;
        }

        return (
            <Accordion id={index}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header className={`${fullPath === this.state.selectedPath ? 'selected' : ''}`}
                        onClick={() => this.onFolderClick(name, node, fullPath)}>
                        {name}
                    </Accordion.Header>
                    <Accordion.Body className="p-0">
                        <ul style={{ paddingLeft: 12 }}>
                            {Object.entries(node).map(([key, child]) => (
                                this.treeNode(child, key, fullPath)
                            ))}
                        </ul>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        );
    };

    _renderFetchStorageFilesFolders = (path, load) => {
        let prefix = path && path !== "" ? path : "Vijay/";
        this.setState({
            initialLoading: true,
            searchWord: "",
            storageFiles: load === true ? [] : this.state.storageFiles,
            storageFolders: load === true ? [] : this.state.storageFolders
        }, () => {
            this.fetchStorageFilesFolders(prefix, null, [], []);
        })
    }

    handleSearch = (e) => {
        let value = e.target.value;
        if (value) {
            this.setState({
                searchWord: value,
                loading: true
            })
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.searchWithPrefixes(value);
            }, 1000);
        }
    }

    searchWithPrefixes = (value) => {
        if (value === "") {
            this.onRefresh();
            return false
        }
        StorageService.listObjectFilter(this.state.prefix ? this.state.prefix : "", value, null, null)
            .then((response) => {
                this.setState({
                    storageFiles: response?.result,
                    storageFolders: response?.prefixes,
                    loading: false
                })
            }).catch((error) => {
                this.setState({
                    loading: false
                })
            })
    }

    onRefresh = () => {
        this.setState({
            searchWord: "",
            loading: false,
            storageFiles: [],
            storageFolders: [],
        }, () => {
            this.fetchStorageFilesFolders(this.state.prefix ? this.state.prefix : "", null, [], []);
        })
    }

    handleToggleTheme = () => {
        this.setState({ toggleTheme: !this.state.toggleTheme })
    }

    render() {
        return (
            <FileEditContext.Provider value={{
                fileContextValue: this.state.fileContextValue,
                expandView: this.state.expandView,
                toggleTheme: this.state.toggleTheme,
                setFileContextValue: this.setFileContextValue,
                setExpandView: this.setExpandView
            }}>
                <Row className="py-2 px-0 app-sticky mx-0">
                    <Col xl={3} lg={5} md={12} sm={12} xs={12}
                        className="d-flex flex-column app-head"
                    // onClick={(e) => this.moveToHome()}
                    >
                        <span className="font-bold main-title">
                            <i className="fa-solid fa-house font20 he-icon"></i>&nbsp;
                            <span>File Editor</span>
                        </span>
                        <span className="font-regular sub-content">Code Editor</span>
                    </Col>
                </Row>
                <div className={`file-editor bg-white d-flex ${this.state.toggleTheme ? 'dark' : 'light'}`}
                    style={{ height: this.state.height - 90 }}>
                    <PanelGroup direction="horizontal">
                        {!this.state.expandView && <Panel minSize={15} defaultSize={20}>
                            <div className={`editor-left ${this.state.initialLoading ? 'treeLoad' : ''}`}>
                                {this.state.initialLoading && <div className="treeLoadWrapp">
                                    <img src={storageLoad} alt="load" />
                                </div>}
                                <div className="tree-input p-2">
                                    <input
                                        type="text"
                                        placeholder="Go to file"
                                        value={this.state.searchWord}
                                        onChange={(e) => this.handleSearch(e)}
                                    />
                                    {this.state.searchWord && this.state.searchWord !== "" ? <span onClick={() => this.onRefresh()}><i className="fa-solid fa-circle-xmark"></i></span> : <span className="pointer-disable"><i className="fa-solid fa-magnifying-glass"></i></span>}
                                </div>
                                <TreeView
                                    files={this.state.storageFiles}
                                    folders={this.state.storageFolders}
                                    loading={this.state.loading}
                                    height={this.state.height}
                                    _renderFetchStorageFilesFolders={this._renderFetchStorageFilesFolders}
                                />
                                <div className="code-editor-setting d-flex align-items-center">
                                    <span className="pe-2">Theme </span>
                                    <input type="checkbox"
                                        className="dark_light"
                                        id="toggleMode"
                                        checked={this.state.toggleTheme}
                                        onChange={this.handleToggleTheme}
                                    />
                                    <label for="toggleMode" className="dark_light_label">
                                        <img className={!this.state.toggleTheme ? 'opacity-0' : ''} src={sun} alt="light" />
                                        <img className={this.state.toggleTheme ? 'opacity-0' : ''} src={moon} alt="dark" />
                                        <img className="dark_light_switch" src={cloud} alt="cloud" />
                                    </label>
                                </div>
                            </div>
                        </Panel>}
                        <PanelResizeHandle className={`sa-resizeHandle ${this.state.expandView ? 'expanded' : ''}`} />
                        <Panel minSize={this.state.expandView ? 100 : 40}>
                            <div className={`editor-right ${this.state.expandView ? 'expanded' : ''}`}>
                                <EditorView />
                            </div>
                        </Panel>
                    </PanelGroup>
                </div>
            </FileEditContext.Provider>
        )
    }
}

const FileEditor = (props) => {
    const location = useLocation();
    return <FileEditorWrapper {...props} location={location} />
}

export default withNavigate(FileEditor);